import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  profileData: {},
  message: {},
};

export const dashboardReducer = createReducer(initialState, {
  [types.DASHBOARD_RESPONSE](state, action) {
    return {
      ...state,
      message: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOGIN_PROFILE_RESPONSE](state, action) {
    return {
      ...state,
      profileData: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
